import { http } from "../core";
import { URL } from "./_url";
import { StatusCode } from "../constant";
import { LeadData } from "../types";

const apiSaveLead = async (leadData: LeadData) => {
    const response = await http.post(URL.SAVE_LEAD(), leadData);
    if (response && response.status >= StatusCode.BADREQUEST) {
        throw new Error(response.status);
    }
    return response || null;
};

export { apiSaveLead };
